import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

function App() {
  const { id } = useParams();
  let [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const type = searchParams.get("type");
    // console.log("query =>", type);
  }, []);
  return (
    <div className="App">
      Product detail param = {id}, and type = {searchParams.get("type")}
    </div>
  );
}

export default App;
